import { IComponentOptions } from 'angular';
import { StudentCreditGapsPanelCourseHistoryCtrl } from './student-credit-gaps-panel-course-history.controller';

export const StudentCreditGapsPanelCourseHistoryComponent: IComponentOptions = {
  bindings: {
    courseDiffs: '<',
    gapPlans: '<',
    school: '<',
    student: '<',
    sharedState: '<',
    isRestricted: '<',
  },
  controller: StudentCreditGapsPanelCourseHistoryCtrl,
  template: require('./student-credit-gaps-panel-course-history.html'),
};
